<script lang="ts" setup>
import Tile from '~/components/cards/Tile.vue'
import type { MenuItem } from '~/types/menus'

defineProps<{
  items: MenuItem[]
}>()
</script>

<template>
  <div>
    <div class="-m-1 flex flex-wrap items-stretch lg:-m-2">
      <Tile v-for="x in items" :key="x.name" class="w-1/2 p-1 lg:w-1/3 lg:p-2" :item="x" />
    </div>
  </div>
</template>
